import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { useIsMobileDevice } from 'hooks/useIsMobileDevice'
import buildLoyaltySelectedUpgradeKey from 'loyalty/lib/benefits/buildLoyaltySelectedUpgradeKey'
import { useContext, useEffect, useMemo } from 'react'

/**
 * This is a temporary measure for MVP where a user selects a target upgrade
 * that is no longer available in the calendar then the calendar picker is closed.
 * This choice was the best of a bad set of options and will optimised post MVP
 * to work with multi-room & multi-cart as well.
 *
 * @TODO: refactor the selectedUpgradeKey to just be the packageUniqueKey
 */
function useLoyaltyOfferPageClearTargetStayUpgrade(
  packageView: App.OfferPackageOptionView | undefined,
) {
  const originPackage = packageView?.package
  const { loyaltyTargetStayUpgradesSelected, checkInDate, activeFilter } = useContext(OfferPageStateContext)
  const offerPageDispatch = useOfferPageDispatch()
  const isMobileDevice = useIsMobileDevice()

  const selectedUpgradeKey = useMemo(() => {
    if (!originPackage) return undefined
    return buildLoyaltySelectedUpgradeKey(originPackage)
  }, [originPackage])

  useEffect(() => {
    if (
      selectedUpgradeKey &&
      loyaltyTargetStayUpgradesSelected?.[selectedUpgradeKey] &&
      (checkInDate && (!activeFilter || (isMobileDevice && activeFilter === 'packageSelection')) && !packageView?.loyaltyUpgradeAvailability)
    ) {
      offerPageDispatch({
        type: OfferPageActions.toggleLoyaltyTargetRoomUpgrade,
        selectedUpgradeKey,
        selectedTargetUpgradeType: undefined,
      })
    }
  }, [
    activeFilter,
    checkInDate,
    isMobileDevice,
    loyaltyTargetStayUpgradesSelected,
    offerPageDispatch,
    packageView?.loyaltyUpgradeAvailability,
    selectedUpgradeKey,
  ])
}

export default useLoyaltyOfferPageClearTargetStayUpgrade
